import { Center } from 'src/design/atoms/Center';
import { Loader } from 'src/design/atoms/Loader';
import { BaseModal } from 'src/design/molecules/BaseModal';
import React, { Suspense } from 'react';

// Keeps the three.js viewer out of the daily form's bundle until it is opened.
const LazyDailyProgressViewer = React.lazy(() =>
  import('src/routes/Operations/Daily/components/DailyProgressViewer').then(
    (m) => ({ default: m.DailyProgressViewer }),
  ),
);

export interface IDailyProgressViewerModalProps {
  opened: boolean;
  onClose: () => void;
  jobId: number;
  jobLabel?: string;
  onStatusesSaved: (progressItemIds: string[]) => void;
  /** Drawing the viewer opens with; the user can still switch drawings. */
  initialDrawingId?: string;
}

export const DailyProgressViewerModal: React.FC<
  IDailyProgressViewerModalProps
> = ({
  opened,
  onClose,
  jobId,
  jobLabel,
  onStatusesSaved,
  initialDrawingId,
}) => (
  <BaseModal
    opened={opened}
    onClose={onClose}
    title={jobLabel ? `Progress viewer - ${jobLabel}` : 'Progress viewer'}
    fullScreen
    // Escape deselects inside the viewer; it must not also close the modal.
    closeOnEscape={false}
    styles={{
      content: { display: 'flex', flexDirection: 'column' },
      body: {
        flex: 1,
        minHeight: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    {opened && (
      <Suspense
        fallback={
          <Center flex={1}>
            <Loader size="lg" />
          </Center>
        }
      >
        <LazyDailyProgressViewer
          jobId={jobId}
          onStatusesSaved={onStatusesSaved}
          initialDrawingId={initialDrawingId}
        />
      </Suspense>
    )}
  </BaseModal>
);
